import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-c489da8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "元感微电子有限公司logo"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-line" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-line" }, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

import { onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

// 定义响应式变量 activeIndex 当前点击的菜单

export default /*#__PURE__*/_defineComponent({
  __name: 'Header2',
  setup(__props) {

const activeIndex = ref<string>("");
const menuItems = [
  { index: "/product", label: "产品介绍" },
  { index: "/service", label: "解决方案" },
  { index: "/dynamics", label: "公司动态" },
  { index: "/about", label: "关于我们" },
];

// 点击菜单的方法
const handleMenuClick = (index: string) => {
  activeIndex.value = index;
  router.push(index); // 路由跳转到对应菜单
  isBurgerActive.value = false; // 点击菜单项时关闭侧边菜单
};

// vue3重定向到首页就把首页的菜单变成激活状态
// 实例化路由
const route = useRoute();
activeIndex.value = route.path;

const router = useRouter();

// 监听路由变化来更新 activeIndex
watch(
  () => route.path,
  (newPath) => {
    activeIndex.value = newPath;
  }
);

// 跳转到产品页
function goProduct() {
  router.push("/product");
}

// 定义一个响应式的布尔变量来跟踪burger是否处于活动状态
const isBurgerActive = ref(false);

// 点击burger时的处理函数
function clickBurger() {
  // 切换isBurgerActive的值
  isBurgerActive.value = !isBurgerActive.value;
}

// // rem自适应 🐸🐸🐸🐸🐸🐸🐸🐸
// // 定义适配函数
// const reScreenSize = () => {
//   let w = document.documentElement.clientWidth; // 获取设备的宽度
//   // console.log("设备宽度是：", w);
//   let newFontSize = 10 * (w / 1920); // 计算新的字体大小
//   // 限制最大字体大小为40px，最小为7.4px
//   newFontSize = Math.max(7.4, Math.min(newFontSize, 40));
//   document.documentElement.style.fontSize = `${newFontSize}px`;
// };

// // 页面加载时执行一次适配
// onMounted(() => {
//   reScreenSize();
//   window.addEventListener("resize", reScreenSize);
// });

// // 页面卸载时移除监听事件
// onUnmounted(() => {
//   window.removeEventListener("resize", reScreenSize);
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goProduct()))
      }, _hoisted_3),
      _createElementVNode("ul", {
        class: _normalizeClass(["menu", ['menu', { open: isBurgerActive.value }]])
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item, index) => {
          return _createElementVNode("li", {
            key: item.index,
            class: _normalizeClass([{
            'menu-item-active': activeIndex.value === item.index,
          }, "menu-item"]),
            onClick: ($event: any) => (handleMenuClick(item.index))
          }, _toDisplayString(item.label), 11, _hoisted_4)
        }), 64))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ burger: true, active: isBurgerActive.value }),
        onClick: clickBurger
      }, _hoisted_8, 2)
    ])
  ]))
}
}

})